export default {
  lang: {
    confirm: {
      title: 'Opravdu ho chcete odstranit? Po odstranění nelze obnovit',
      okText: 'Smazat',
      cancelText: 'Storno',
    },
  },
};
